import { render, staticRenderFns } from "./project-type-3.html?vue&type=template&id=312fdace&scoped=true&external"
import script from "./project-type-3.js?vue&type=script&lang=js&external"
export * from "./project-type-3.js?vue&type=script&lang=js&external"
import style0 from "./project-type-3.scss?vue&type=style&index=0&id=312fdace&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312fdace",
  null
  
)

export default component.exports